/* BunnyBox: "Voeg onze hardloper toe?" in de lege winkelwagen.
   Voegt het product toe via de AJAX-cart en laat Horizon de lade bijwerken
   (zelfde CartLinesUpdateEvent als het productformulier). Zonder JavaScript
   werkt het formulier gewoon als /cart/add. */
import { CartLinesUpdateEvent } from '@shopify/events';

class BbCartSuggest extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form || this.bound) return;
    this.bound = true;
    this.form.addEventListener('submit', (e) => this.add(e));
  }

  async add(event) {
    event.preventDefault();
    const btn = this.form.querySelector('button');
    const id = Number(this.dataset.variant);
    if (!id || (btn && btn.disabled)) return;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((c) => c.dataset.sectionId)
      .filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(id), quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const res = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionIds.join(',') }),
      }).then((r) => r.json());
      if (res.status) throw new Error(res.message || this.dataset.err || 'Error');

      const cart = await fetch(Theme.routes.cart_url + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then((r) => r.json());

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'bb-cart-suggest',
          itemCount: 1,
          productId: this.dataset.product,
          sections: res.sections,
          didError: false,
        },
      });
    } catch (err) {
      deferred.reject(err);
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      console.warn('[bb-cart-suggest]', err);
    }
  }
}

if (!customElements.get('bb-cart-suggest')) customElements.define('bb-cart-suggest', BbCartSuggest);
